
import HomePage from '../pages/home.vue';
import PanelLeftPage from '../pages/panel-left.vue';

import LoginPage from '../pages/login.vue';
import RegistrationPage from '../pages/registration.vue';
import ProfilePage from '../pages/profile.vue';

import AboutPage from '../pages/about.vue';
import PrivacyPage from '../pages/privacy.vue';
import FormPage from '../pages/form.vue';

import EventDetailspage from '../pages/event-details.vue';
import FeedbackPage from '../pages/feedback.vue';
import FeedbackListPage from '../pages/feedback-list.vue';
import UpcomingPage from '../pages/upcoming.vue';

import CalendarPage from '../pages/calendar.vue';
import QuestionPage from '../pages/question.vue';


import DynamicRoutePage from '../pages/dynamic-route.vue';
import RequestAndLoad from '../pages/request-and-load.vue';
import NotFoundPage from '../pages/404.vue';

import Articles from '../pages/articles.vue';
import ArticleDetails from '../pages/article-details.vue';

import News from '../pages/news.vue';
import NewsDetails from '../pages/news-details.vue';
import ForgotPassword from '../pages/forgot-password.vue';
import ResetPassword from '../pages/reset-password.vue';
import Contact from '../pages/contact.vue';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/panel-left/',
    component: PanelLeftPage,
  },
  {
    path: '/login/',
    component: LoginPage,
  },
  {
    path: '/contact/',
    component: Contact,
  },
  {
    path: '/forgot-password/',
    component: ForgotPassword,
  },
  {
    path: '/reset-password/',
    component: ResetPassword,
  },
  {
    path: '/registration/',
    component: RegistrationPage,
  },
  {
    path: '/profile/',
    component: ProfilePage,
  },
  {
    path: '/feedback/',
    component: FeedbackPage,
  },
  {
    path: '/calendar/',
    component: CalendarPage,
  },
  {
    path: '/quiz/',
    component: QuestionPage,
  },
  {
    path: '/feedback-list/',
    component: FeedbackListPage,
  },
  {
    path: '/upcoming/',
    component: UpcomingPage,
  },
  {
    path: '/event-details/:event_id',
    component: EventDetailspage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/privacy/',
    component: PrivacyPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/articles/',
    component: Articles,
  },
  {
    path: '/article-details/',
    component: ArticleDetails,
  },
  {
    path: '/news/',
    component: News,
  },
  {
    path: '/news-details/',
    component: NewsDetails,
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
